var render = function render(){var _vm=this,_c=_vm._self._c;return _c('chip-component',{attrs:{"payload":_vm.getStatus}})
}
var staticRenderFns = []

export { render, staticRenderFns }